// Libs
import { pipe } from 'fp-ts/lib/function';
import { replace, split } from 'lodash/fp';

export const parseControlValuesFromDISFormat = (value: string): string[] =>
  pipe(value, replace('{', ''), replace('}', ''), split(','));
